var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDropUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.246857 4.64657L4.91168 0.230155C5.06803 0.0827423 5.27954 2.50049e-07 5.5 2.40413e-07C5.72046 2.30776e-07 5.93197 0.0827423 6.08832 0.230155L10.7531 4.64657C10.8708 4.75727 10.9511 4.89871 10.9837 5.05285C11.0163 5.20698 10.9998 5.36684 10.9362 5.51203C10.8726 5.65722 10.7649 5.78117 10.6268 5.86807C10.4887 5.95498 10.3264 6.0009 10.1607 5.99999L0.839349 5.99999C0.673598 6.0009 0.511313 5.95498 0.373188 5.86807C0.235063 5.78117 0.127355 5.65722 0.0637934 5.51203C0.000232931 5.36684 -0.0163 5.20698 0.0163033 5.05285C0.0489065 4.89871 0.129169 4.75727 0.246857 4.64657Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropUp);
export default __webpack_public_path__ + "static/media/iconDropUp.ee78b5a61f9cbb0260b236beb5e09c70.svg";
export { ForwardRef as ReactComponent };